var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.items, function(pagePart) {
      return _vm.canShow(pagePart)
        ? _c(
            "div",
            { key: pagePart.id },
            [
              _c(
                "LazyHydrate",
                {
                  attrs: {
                    "when-visible": "",
                    "trigger-hydration": _vm.mustHydrateImmediately(pagePart)
                  }
                },
                [
                  _c(pagePart.componentName, {
                    tag: "component",
                    attrs: {
                      pagePartId: pagePart.id,
                      items: _vm.pagePartItems(pagePart),
                      classNames: pagePart.classNames,
                      isOnlyForUser: pagePart.isOnlyForUser,
                      isOnlyForGuest: pagePart.isOnlyForGuest,
                      showPrintContentButton: pagePart.showPrintContentButton,
                      showDownloadContentButton:
                        pagePart.showDownloadContentButton,
                      settings: pagePart.settings,
                      componentContent: pagePart.componentContent
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }